import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Site } from 'src/app/api/site/site';
import { SiteApiService } from 'src/app/api/site/siteApiService';

@Component({
    selector: 'site-details',
    templateUrl: './site-details.component.html',
    styleUrls: ['./site-details.component.css'],
    host: {'class': 'site-details'},
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SiteDetailsComponent implements OnInit {
  @Input() siteId: number | null | undefined = null;
  @Input() site: Site | null | undefined = null;
  loading: boolean = false;

  constructor(
    private siteApiService: SiteApiService
  ) { }

  ngOnInit(): void {
    if(this.site)
      return;

    if (this.siteId == undefined)
      return;

    this.loading = true;
    this.siteApiService.getSite(this.siteId)
      .subscribe(x => {
        this.loading = false;
        this.site = x
      });

  }
}
